import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import FeaturedCard from "./homepage/FeaturedCard";
import { Link } from "react-router-dom";
import aboutAPI from "../api/aboutApi";

const AboutUs = () => {
  const [aboutUs, setAboutUs] = useState([]);
  const [ourMission, setOurMission] = useState([]);
  const [mrvPillars, setMrvPillars] = useState([]);
  const [parentTrust, setParentTrust] = useState([]);
  const [ecoCommitment, setEcoCommitment] = useState([]);
  const [aiCertified, setAiCertified] = useState([]);
  const [certificates, setCertificates] = useState([]);


  useEffect(() => {
    fetchAboutDetails();
    fetchCertificates();
  }, []);

  const fetchAboutDetails = async () => {
    const res = await aboutAPI.listing();

    if (res.code === 200) {
      const result = res.data;

      setAboutUs(result?.about_us);
      setOurMission(result?.our_mission);
      setMrvPillars(result?.mrv_pillars);
      setParentTrust(result?.parent_trust);
      setEcoCommitment(result?.eco_commitment);
      setAiCertified(result?.aicertified);
    }
  };

  const fetchCertificates = async () => {
    try {
      const res = await aboutAPI.certificates();

      if (res.code === 200) {
        setCertificates(res.data || []);
      }
    } catch (error) {
      console.error("Error fetching certificates:", error);
    }
  };

  const aboutInfo = aboutUs[0];
  const trustInfo = parentTrust[0];
  const ecoInfo = ecoCommitment[0];
  const aiInfo = aiCertified[0];


  return (
    <>
      <BreadCrumbBanner
        title="About Us"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* About Us Section */}
      {aboutUs && aboutUs.length > 0 && (
        <section className="premium-about-section py-5">
          <div className="container">
            <div className="row align-items-stretch g-5">
              <div className="col-lg-6">
                <div className="image-stack h-100">
                  <div className="stack-item main-img h-100">
                    <img
                      src={aboutInfo?.image}
                      alt="School Life"
                      loading="lazy"
                      className="img-fluid shadow-sm h-100 w-100"
                      style={{ objectFit: "cover" }}
                    />
                  </div>
                  <div className="floating-card about-logo-card">
                    <div className="about-logo-circle">
                      <img
                        src={aboutInfo?.logo || `${process.env.PUBLIC_URL}/assets/images/logo1.png`}
                        loading="lazy"
                        alt="MRV Logo"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 d-flex flex-column justify-content-center">
                <div className="content-wrapper">
                  <h6 className="mrv-subtitle fw-bold text-uppercase">
                    {aboutInfo?.type}
                  </h6>
                  <h2 className="mrv-title mb-3">{aboutInfo?.name}</h2>
                  <p className="mb-4 description-p">
                    <div dangerouslySetInnerHTML={{ __html: aboutInfo.description }} />
                  </p>

                  {/* <div className="cta-wrap">
                    <Link to="/facilities" className="mrv-btn-outline text-decoration-none">
                      Explore Our Facilities <i className="bi bi-arrow-right ms-2" />
                    </Link> 
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Vision & Mission Section */}
      {ourMission && ourMission.length > 0 && (
        <section className="minimal-vm-static py-5">
          <div className="container">
            <div className="row g-0 align-items-stretch border-top border-bottom">
              {ourMission.map((item, index) => (
                <div
                  key={item.id}
                  className={`col-md-6 v-m-box-static ${index === 0 ? "border-end" : ""}`}
                >
                  <div className="content-wrap p-4 p-lg-5">
                    <div className="header-group">
                      <span className="mrv-subtitle fw-bold text-uppercase">
                        {item.type}
                      </span>
                      <h2 className="mrv-title m-0">{item.title}</h2>
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: item.short_description }} />
                    <div
                      className="text-container mt-3"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* MRV Pillars Section */}
      {mrvPillars && mrvPillars.length > 0 && (
        <section className="mrv-why-us py-5 bg-light">
          <div className="container py-5">
            <div className="text-left mb-3">
              <h6 className="text-maroon fw-bold text-uppercase">Our Foundations</h6>
              <h2 className="mrv-title">The Pillars of MRV School</h2>
            </div>
            <div className="row g-4">
              {mrvPillars.map((item, index) => (
                <div key={item.id} className="col-lg-3 col-md-6">
                  <FeaturedCard
                    item={{
                      icon: item.logo,
                      title: item.name,
                      desc: item.description.replace(/<[^>]+>/g, ""),
                    }}
                    index={index}
                  />
                </div>
              ))}
            </div>
          </div>
        </section>
      )}

      {/* Why Parents Trust Section */}
      {parentTrust && parentTrust.length > 0 && (
        <section className="mrv-about-highlights-static py-5">
          <div className="container">
            <div className="row g-5 align-items-center">
              <div className="col-lg-5">
                <div className="header-content-wrap">
                  <h6 className="mrv-subtitle fw-bold text-uppercase">
                    {trustInfo?.title}
                  </h6>
                  <h2 className="mrv-title mb-3">{trustInfo?.subtitle}</h2>
                  <div
                    className="text-muted mb-4 lead-sm"
                    dangerouslySetInnerHTML={{ __html: trustInfo?.description }}
                  />
                </div>
              </div>
              <div className="col-lg-7">
                <div
                  className="mrv-static-list"
                  dangerouslySetInnerHTML={{ __html: trustInfo?.listingdescription }}
                />
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Eco Commitment Section */}
      {ecoCommitment && ecoCommitment.length > 0 && (
        <section className="green-campus-section py-5 position-relative overflow-hidden">
          <div className="leaf-element leaf-1"><i className="bi bi-leaf-fill" /></div>
          <div className="leaf-element leaf-2"><i className="bi bi-leaf-fill" /></div>
          <div className="container">
            <div className="row align-items-stretch">
              <div className="col-lg-6 mb-4 mb-lg-0">
                <div className="campus-image-wrapper h-100">
                  <img
                    src={ecoInfo?.image}
                    alt="Green Campus"
                    loading="lazy"
                    className="img-fluid rounded-custom shadow-lg equal-height-img"
                  />
                  <div className="tree-counter-badge">
                    <h2 className="fw-bold mb-0">500+</h2>
                    <p className="mb-0 small text-uppercase fw-bold">Trees Planted</p>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="content-box-mrv h-100 d-flex flex-column justify-content-center ps-lg-5">
                  <span className="badge-eco mb-3">
                    <i className="bi bi-tree-fill me-2" />
                    {ecoInfo?.title}
                  </span>
                  <h2 className="mrv-title mb-3">{ecoInfo?.subtitle}</h2>
                  <div dangerouslySetInnerHTML={{ __html: ecoInfo?.description }} />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* AI Certified Section */}
      {aiCertified && aiCertified.length > 0 && (
        <section className="clean-ai-section">
          <div className="container">
            <div className="text-center mb-5">
              <h2 className="mrv-title">
                Delhi's First{" "}
                <span style={{ color: "var(--secondary-color)" }}>AI-Certified</span>{" "}
                School
              </h2>
              <div
                className="text-muted mx-auto"
                style={{ maxWidth: "fit-content" }}
                dangerouslySetInnerHTML={{ __html: aiInfo?.shortdescription }}
              />
            </div>
            <div className="row align-items-center">
              <div className="col-lg-4">
                <div className="content-box align-right">
                  <div className="icon-box"><i className="fas fa-microchip" /></div>
                  <div dangerouslySetInnerHTML={{ __html: aiInfo?.description1 }} />
                </div>
                <div className="content-box align-right">
                  <div className="icon-box"><i className="fas fa-shield-halved" /></div>
                  <div dangerouslySetInnerHTML={{ __html: aiInfo?.description2 }} />
                </div>
              </div>
              <div className="col-lg-4 text-center">
                <div className="position-relative d-inline-block">
                  <img
                    src={`${process.env.PUBLIC_URL}/assets/img/ai.png`}
                    className="ai-main-img"
                    alt="AI Education"
                    loading="lazy"
                  />
                  <div className="position-absolute bottom-0 end-0 bg-white p-2 rounded-circle shadow">
                    <i className="fas fa-check-circle text-success fa-2x" />
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="content-box align-left">
                  <div className="icon-box"><i className="fas fa-chalkboard-user" /></div>
                  <div dangerouslySetInnerHTML={{ __html: aiInfo?.description3 }} />
                </div>
                <div className="content-box align-left">
                  <div className="icon-box"><i className="fas fa-chart-line" /></div>
                  <div dangerouslySetInnerHTML={{ __html: aiInfo?.description4 }} />
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* certifications */}
      <section className="custom-certificates-section">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="mrv-title">
              Our{" "}
              <span style={{ color: "var(--secondary-color)" }}>Certificates</span>
            </h2>
            <p
              className="text-muted mx-auto"
              style={{ maxWidth: "fit-content" }}
            > Our certifications reflect our commitment to quality,
              excellence and industry standards.</p>
          </div>

          <div className="row g-3">
            {certificates.map((certificate) => (
              <div
                className="col-lg-3 col-md-4"
                key={certificate.id}
              >
                <div className="custom-certificate-card">

                  <div className="custom-certificate-icon">
                    <i className="bi bi-award-fill"></i>
                  </div>

                  <h3>{certificate.title}</h3>


                  <a
                    href={`/certificate/${certificate.slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="custom-view-certificate"
                  >
                    <span>View Certificate</span>
                    <i className="bi bi-arrow-up-right"></i>
                  </a>

                </div>
              </div>
            ))}
          </div>

        </div>
      </section>
    </>
  );
};

export default AboutUs;